// extracted by mini-css-extract-plugin
module.exports = {"formWrapper":"ProgramEligibilityForm__formWrapper___QCB_5","buttons":"ProgramEligibilityForm__buttons___sA4sD"};